import { render, staticRenderFns } from "./OtherPropertyNewInsurance.vue?vue&type=template&id=4b4c0e69"
import script from "./OtherPropertyNewInsurance.vue?vue&type=script&lang=js"
export * from "./OtherPropertyNewInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports